import { render, staticRenderFns } from "./PanelOpener.vue?vue&type=template&id=1ed0a94d&scoped=true"
import script from "./PanelOpener.vue?vue&type=script&lang=ts"
export * from "./PanelOpener.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed0a94d",
  null
  
)

export default component.exports